var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowUpRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-mini/arrow-up-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1938 36.112C13.8968 36.8149 15.0365 36.8149 15.7394 36.112L33.0666 18.7847V32.4392C33.0666 33.4333 33.8725 34.2392 34.8666 34.2392C35.8607 34.2392 36.6666 33.4333 36.6666 32.4392V14.4392C36.6666 13.445 35.8607 12.6392 34.8666 12.6392H16.8666C15.8725 12.6392 15.0666 13.445 15.0666 14.4392C15.0666 15.4333 15.8725 16.2392 16.8666 16.2392H30.521L13.1938 33.5664C12.4909 34.2693 12.4909 35.409 13.1938 36.112Z",
    fill: "#22C55E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpRight);
export default __webpack_public_path__ + "static/media/arrow-up-right.c970ee52355e1c651c7c8193c3fa793d.svg";
export { ForwardRef as ReactComponent };